import { render, staticRenderFns } from "./ViewAllBills.vue?vue&type=template&id=48eaaa63&"
import script from "./ViewAllBills.vue?vue&type=script&lang=js&"
export * from "./ViewAllBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewAllBills.vue"
export default component.exports